/**
 * Session storage keys used by the application.
 */
export const STORAGE_KEYS = {
  CELERO_APP_STARTED: 'celeroAppStarted',
} as const;
